// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"caf2040d","513":"96fcf123","703":"9f24dc10"}[chunkId] + ".chunk.js";
};